"use client"

import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import dynamic from "next/dynamic"

import { selectCloseEntryFlow, selectEntryFlowSeed, useEntryFlowStore } from "@/lib/store/entry-flow-store"

/* =============================================================================
   The entry flow over the Board, raised the moment a lineup is placed.

   Reads the placed lineup from the entry-flow store and shows the prototype
   at /arena/entry-flow with those picks in it, full screen, above the slip.
   Closing (X, scrim, "Back to the board") clears the store, and the Board is
   exactly where it was left.

   Client-only for the same reason the route is: the flow's clock is anchored
   to load time.
   ============================================================================= */

const EntryFlowPrototype = dynamic(
  () => import("@/components/arena/entry-flow/entry-flow").then((m) => m.EntryFlowPrototype),
  { ssr: false }
)




export function EntryFlowDialog() {
  const seed = useEntryFlowStore(selectEntryFlowSeed)
  const close = useEntryFlowStore(selectCloseEntryFlow)

  return (
    <DialogPrimitive.Root open={seed !== null} onOpenChange={(open) => !open && close()}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[70] bg-black/80 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          className="fixed inset-0 z-[70] overflow-y-auto px-4 py-6 outline-none"
          // The content covers the screen so the card can scroll, which means a
          // tap beside the card lands here rather than on the overlay. Anything
          // the flow marks as its own (toolbar, card, its overlays) keeps it open.
          onClick={(e) => {
            if (!(e.target as Element).closest("[data-entry-flow-keep]")) close()
          }}
        >
          <DialogPrimitive.Title className="sr-only">Your entry</DialogPrimitive.Title>
          {seed && <EntryFlowPrototype seed={seed} onExit={close} className="min-h-full justify-center py-10" />}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
